import { workspace } from './workspace';

export const publicRoutes = ($http: HttpApi) => ({
  workspace: workspace($http),
});
